class Toggles  {

	constructor(args) {
		if( $(".bjzm-toggles__link").length > 0 ) {
			this.handleEvents();
			// this.setFirstSlideActive();
		}
	}
	
	handleEvents() {
		$(".bjzm-toggles__link").on('click', (e) => {
			e.preventDefault();
			var $target = $(e.currentTarget);
			var activeSlideKey = $target.data('toggle');
			$target.parent().addClass('bjzm-toggles__item--active').siblings().removeClass('bjzm-toggles__item--active');
			// this.activeSlideKey = key;
			this.setActiveSlide( $target, activeSlideKey );
		});
	}

	setFirstSlideActive($target) {
		var height = $(".bjzm-toggles__section:first").outerHeight();
			$(".toggles__sections").height(height);
			$(".bjzm-toggles__section:first").addClass('bjzm-toggles__section--active');
			$(".bjzm-toggles__link:first").parent().addClass('bjzm-toggles__item--active');
	}
	
	setActiveSlide($target, activeSlideKey) {
		
		var $parentToggles = $target.closest('.bjzm-toggles').find('.bjzm-toggles__sections');

		var selector = `.${activeSlideKey}`;

		var $activeSlide =  $(selector);
		var height = $activeSlide.height();
		$parentToggles.animate({
			'opacity': 0
			}, 
			{
				duration: 300, 
				complete: () => {
					$parentToggles.height(height);
				}
			});
		
		setTimeout(function(){
			$activeSlide.addClass('bjzm-toggles__section--active').siblings().removeClass('bjzm-toggles__section--active');
			$parentToggles.animate({opacity: 1}, 300);
		}, 300);


	}

}

module.exports = Toggles;